/* =====================================================================================================================
   batida-v7-evt.js (7.10, Aleksandra): the scripts of /pages/slodki-stol-na-event and /pages/stacja-speciality, ported
   1:1 from her mockups (outputs/2026-10-07/nowe-strony/z1, the <script> at the end of each index.html). Sections:
   batida-v7-evt-*, batida-v7-slodki-stol-calc, batida-v7-stacja-*. Runs once however many sections include it.
   - Słodki stół calculator ([data-v7e-ss]): the mockup's calc() - need = guests x pieces per person, sets by role
     (sez / owo / tar / vir) + savoury sets; prices = the live products (config [data-v7e-ss-cfg], grosze).
     "Dodaj zestawy do koszyka" + the "+" on the cards: POST /cart/add.js, full /cart.js -> theme:cart:change ->
     the cart drawer (window.__batidaOpenCart), like batida-v7-paczka.js.
   - Stacja calculator ([data-v7e-st]): the mockup's calc() - price list per guest tier, extra hours (rate netto x
     guests x hours x VAT), cups with logo (max(min, guests x per person) x price x VAT); above the last tier = "wycena".
     Package cards' buttons ([data-v7e-setpk]) switch the package; links to #wycena fill the form (people, package,
     cups) like the mockup.
   - Gallery: "Zobacz więcej" + lightbox (alt text as caption, Esc / click closes). Package comparison toggle.
   - Enquiry forms ([data-v7e-form], posted by batida-v7-forms.js): date min = tomorrow, sent as dd.mm.rrrr through a
     hidden twin; logo upload to Batida Connect (POST /apps/connect/forms/upload?name=&form=, raw body, {ok, url}) ->
     contact[Logo]; on 404 / failure the form still goes, with the "(logo nie zostało wysłane ...)" note in that field.
   ===================================================================================================================== */
(function () {
  'use strict';
  if (window.__v7Evt) return;
  window.__v7Evt = 1;

  var UPLOAD = '/apps/connect/forms/upload', MAX = 10 * 1024 * 1024, EXT = /\.(png|svg|jpe?g|webp|pdf)$/i;

  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function cfg(root, sel) { try { return JSON.parse(root.querySelector(sel).textContent); } catch (e) { return null; } }
  function root() { return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, ''); }

  /* ---------- toast (the mockup's toast()) ---------- */
  var toastEl, toastT;
  function toast(m) {
    if (!m) return;
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'v7e-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = m;
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2200);
  }

  /* ---------- cart ---------- */
  function addItems(items) {
    function post(list) {
      return fetch(root() + '/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: list }) });
    }
    return post(items).then(function (r) {
      if (r.ok) return 0;
      var failed = 0, p = Promise.resolve();               // one of them can't be added (sold out?): the rest one by one
      items.forEach(function (it) { p = p.then(function () { return post([it]).then(function (r2) { if (!r2.ok) failed++; }, function () { failed++; }); }); });
      return p.then(function () { return failed; });
    }).then(function (failed) {
      return fetch(root() + '/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        try { document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart } })); } catch (e) { /* old browsers */ }
      }).catch(function () {}).then(function () {
        if (typeof window.__batidaOpenCart === 'function') window.__batidaOpenCart();
        return failed;
      });
    });
  }

  /* ---------- Słodki stół calculator ---------- */
  function initSS(el) {
    var C = cfg(el, '[data-v7e-ss-cfg]');
    if (!C) return;
    var S = C.sets || {}, T = C.t || {}, pp = 3, salty = false, LAST = [];
    var range = el.querySelector('[data-v7e-range]'), rowsEl = el.querySelector('[data-v7e-rows]'), totalEl = el.querySelector('[data-v7e-total]');
    var pplEl = el.querySelector('[data-v7e-ppl]'), pcsEl = el.querySelector('[data-v7e-pcs]'), savlist = el.querySelector('[data-v7e-savlist]');
    var savnote = el.querySelector('[data-v7e-savnote]'), tog = el.querySelector('[data-v7e-salty]'), cartBtn = el.querySelector('[data-v7e-cart]');
    var seg = el.querySelectorAll('.v7e-seg button');
    if (seg[0]) pp = +seg[0].getAttribute('data-pp') || 3;
    function fmt(cents) {
      if (C.grosze && window.batidaMoney) return window.batidaMoney(cents).replace('ZŁ', 'zł');
      var z = Math.round(cents) / 100;
      // 7.10 (Aleksandra): thousands with a space like the rest of the shop ("1 313,00 zł"), never the browser's "1.313,00"
      var dec = C.grosze || z % 1 ? 2 : 0, parts = z.toFixed(dec).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + (dec ? ',' + parts[1] : '') + ' zł';
    }
    function calc() {
      if (!range) return;
      var ppl = +range.value;
      if (pplEl) pplEl.textContent = ppl;
      var need = ppl * pp;
      if (pcsEl) pcsEl.textContent = String(T.pcs || '{n}').replace('{n}', need);
      var sez = S.sez, owo = S.owo, tar = S.tar, vir = S.vir;
      var nSez = sez ? Math.max(1, Math.round(need * 0.5 / sez.q)) : 0;
      var nOwo = owo ? Math.max(0, Math.round(need * 0.3 / owo.q)) : 0;
      var rest = need - (sez ? nSez * sez.q : 0) - (owo ? nOwo * owo.q : 0);
      var nTar = tar ? Math.max(0, Math.ceil(rest / tar.q)) : 0;
      var nVir = vir && ppl >= 30 ? Math.ceil(ppl / 30) : 0;
      var lines = [[nSez, sez, ''], [nOwo, owo, ''], [nTar, tar, ''], [nVir, vir, 'vir']];
      if (salty && savlist) {
        var ch = Array.prototype.filter.call(savlist.querySelectorAll('input[type=checkbox]'), function (c) { return c.checked; });
        ch.forEach(function (c) {
          var s = { n: c.getAttribute('data-n'), q: +c.getAttribute('data-q') || 1, p: +c.getAttribute('data-p') || 0, id: +c.getAttribute('data-id') || 0 };
          lines.push([Math.ceil(ppl * (C.salty || 2) / ch.length / s.q), s, 'sav']);
        });
      }
      var t = 0;
      LAST = lines.filter(function (l) { return l[1] && l[0] > 0; });
      rowsEl.innerHTML = LAST.map(function (l) {
        var n = l[0], s = l[1];
        t += n * s.p;
        var note = l[2] === 'vir' && T.vir ? ' · ' + T.vir : l[2] === 'sav' && T.sav ? ' · ' + T.sav : '';
        return '<div class="v7e-row"><span class="v7e-q">' + n + '×</span><span><b>' + esc(s.n) + '</b><small>' + (n * s.q) + ' ' + esc(T.unit || 'szt.') + esc(note) + '</small></span><span class="v7e-p">' + fmt(n * s.p) + '</span></div>';
      }).join('');
      totalEl.textContent = fmt(t);
      if (cartBtn) cartBtn.disabled = !LAST.some(function (l) { return l[1].id; });
    }
    if (range) range.addEventListener('input', calc);
    Array.prototype.forEach.call(seg, function (b) {
      b.addEventListener('click', function () {
        Array.prototype.forEach.call(seg, function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        pp = +b.getAttribute('data-pp') || pp;
        calc();
      });
    });
    if (tog) tog.addEventListener('click', function () {
      salty = !salty;
      tog.classList.toggle('is-on', salty);
      tog.setAttribute('aria-pressed', salty ? 'true' : 'false');
      if (savlist) savlist.classList.toggle('is-on', salty);
      if (savnote) savnote.hidden = !salty;
      calc();
    });
    if (savlist) savlist.addEventListener('change', calc);
    if (cartBtn) cartBtn.addEventListener('click', function () {
      var map = {}, items = [], skipped = 0;
      LAST.forEach(function (l) { if (!l[1].id) { skipped++; return; } map[l[1].id] = (map[l[1].id] || 0) + l[0]; });
      Object.keys(map).forEach(function (id) { items.push({ id: +id, quantity: map[id] }); });
      if (!items.length || cartBtn.classList.contains('is-loading')) return;
      cartBtn.classList.add('is-loading');
      addItems(items).then(function (failed) {
        cartBtn.classList.remove('is-loading');
        toast(failed || skipped ? T.err : T.added);
      }, function () { cartBtn.classList.remove('is-loading'); toast(T.err); });
    });
    el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-v7e-add]');
      if (!b || b.classList.contains('is-loading')) return;
      b.classList.add('is-loading');
      addItems([{ id: +b.getAttribute('data-v7e-add'), quantity: 1 }]).then(function (failed) {
        b.classList.remove('is-loading');
        toast(failed ? T.err : String(T.added1 || '').replace('{nazwa}', b.getAttribute('data-n') || ''));
      }, function () { b.classList.remove('is-loading'); toast(T.err); });
    });
    calc();
  }

  /* ---------- Stacja calculator ---------- */
  var ST = null;
  function initST(el) {
    var C = cfg(el, '[data-v7e-st-cfg]');
    if (!C || !C.tiers || !C.tiers.length) return;
    var T = C.t || {}, pk = 'b', h = C.baseH || 3, cups = false, vat = 1 + (C.vat || 0) / 100, last = C.tiers[C.tiers.length - 1];
    var range = el.querySelector('[data-v7e-range]'), rowsEl = el.querySelector('[data-v7e-rows]'), totalEl = el.querySelector('[data-v7e-total]');
    var pplEl = el.querySelector('[data-v7e-ppl]'), overEl = el.querySelector('[data-v7e-over]'), cupsTog = el.querySelector('[data-v7e-cups]');
    var seg = el.querySelectorAll('.v7e-seg button'), hrs = el.querySelectorAll('.v7e-hrs button');
    var NM = { b: T.nb, p: T.np };
    function fmt(n) {
      if (C.grosze && window.batidaMoney) return window.batidaMoney(Math.round(n * 100)).replace('ZŁ', 'zł');
      return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + ' zł';
    }
    function row(q, name, small, price) {
      return '<div class="v7e-row"><span class="v7e-q">' + esc(q) + '</span><span><b>' + esc(name) + '</b><small>' + esc(small) + '</small></span><span class="v7e-p">' + fmt(price) + '</span></div>';
    }
    function calc() {
      var v = +range.value, over = v > last;
      pplEl.textContent = over ? T.over : v;
      if (overEl) overEl.classList.toggle('is-on', over);
      if (over) { rowsEl.innerHTML = ''; totalEl.textContent = T.quote; return; }
      var i = 0;
      while (i < C.tiers.length - 1 && C.tiers[i] < v) i++;
      var base = (C.p[pk] || [])[i] || 0, t = base;
      var html = row(v, NM[pk], String(T.base || '').replace('{h}', C.baseH).replace('{cena}', fmt(base / v)), base);
      if (h > C.baseH) {
        var rate = C.hr[pk] || 0, x = (h - C.baseH) * v * rate * vat;
        t += x;
        html += row('+' + (h - C.baseH) + ' h', T.xh, String(T.xhs || '').replace('{stawka}', rate).replace('{n}', v).replace('{h}', h - C.baseH), x);
      }
      if (cups) {
        var q = Math.max(C.cupMin || 0, v * (C.cupPP || 0)), y = q * (C.cup || 0) * vat;
        t += y;
        html += row('+', T.cups, String(T.cupss || '').replace('{q}', q).replace('{cena}', C.cup) + (q === C.cupMin ? T.cupsMin : T.cupsPP), y);
      }
      rowsEl.innerHTML = html;
      totalEl.textContent = fmt(t);
    }
    function setPk(k) {
      pk = k === 'p' ? 'p' : 'b';
      Array.prototype.forEach.call(seg, function (x) { x.classList.toggle('is-on', x.getAttribute('data-pk') === pk); });
      calc();
    }
    range.addEventListener('input', calc);
    Array.prototype.forEach.call(seg, function (b) { b.addEventListener('click', function () { setPk(b.getAttribute('data-pk')); }); });
    Array.prototype.forEach.call(hrs, function (b) {
      b.addEventListener('click', function () {
        Array.prototype.forEach.call(hrs, function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        h = +b.getAttribute('data-h') || C.baseH;
        calc();
      });
    });
    if (cupsTog) cupsTog.addEventListener('click', function () {
      cups = !cups;
      cupsTog.classList.toggle('is-on', cups);
      cupsTog.setAttribute('aria-pressed', cups ? 'true' : 'false');
      calc();
    });
    ST = { setPk: setPk, state: function () { return { v: +range.value, last: last, pk: pk, cups: cups }; } };
    calc();
  }

  /* links to #wycena carry the calculator into the form (mockup: people, package, cups) */
  function prefill() {
    if (!ST) return;
    var s = ST.state(), f = document.querySelector('form[data-v7e-form]');
    if (!f) return;
    var ppl = f.querySelector('[data-v7e-fppl]');
    if (ppl && s.v <= s.last) ppl.value = s.v;
    var r = f.querySelector('[data-v7e-fpk] input[data-i="' + (s.pk === 'p' ? 1 : 0) + '"]');
    if (r) r.checked = true;
    var c = f.querySelector('[data-v7e-fcups]');
    if (c) c.checked = s.cups;
  }

  /* ---------- gallery + lightbox ---------- */
  // 7.10 (Aleksandra 21:01, phone): the open photo can move to the next / previous one - arrows, swipe, keyboard arrows
  var lb, lbList = [], lbI = 0;
  function lbShow(i) {
    if (!lbList.length) return;
    lbI = (i + lbList.length) % lbList.length;
    var img = lbList[lbI], big = lb.querySelector('img');
    big.src = img.currentSrc || img.src;
    big.alt = img.alt;
    lb.querySelector('p').textContent = img.alt + (lbList.length > 1 ? '  ·  ' + (lbI + 1) + ' / ' + lbList.length : '');
  }
  function lbClose() { if (lb) lb.classList.remove('is-on'); }
  function lightbox(img) {
    if (!lb) {
      lb = document.createElement('div');
      lb.className = 'v7e-lb';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.innerHTML = '<img alt=""><p></p>' +
        '<button type="button" class="v7e-lb__nav v7e-lb__prev" aria-label="Poprzednie zdjęcie">\u2039</button>' +
        '<button type="button" class="v7e-lb__nav v7e-lb__next" aria-label="Następne zdjęcie">\u203A</button>' +
        '<button type="button" class="v7e-lb__x" aria-label="Zamknij">\u00D7</button>';
      lb.addEventListener('click', function (e) {
        if (e.target.closest('.v7e-lb__prev')) { lbShow(lbI - 1); return; }
        if (e.target.closest('.v7e-lb__next')) { lbShow(lbI + 1); return; }
        if (e.target.tagName === 'IMG') { lbShow(lbI + 1); return; }   // a tap on the photo = the next one
        lbClose();
      });
      var x0 = null, y0 = 0;
      lb.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0; x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { lbShow(lbI + (dx < 0 ? 1 : -1)); }
      }, { passive: true });
      document.body.appendChild(lb);
    }
    var box = img.closest('[data-v7e-gallery]') || img.closest('.v7e-gal') || document;
    lbList = Array.prototype.slice.call(box.querySelectorAll('.v7e-gal figure img'));
    var i = lbList.indexOf(img); if (i < 0) { lbList = [img]; i = 0; }
    lb.classList.toggle('is-single', lbList.length < 2);
    lbShow(i);
    lb.classList.add('is-on');
  }

  /* ---------- enquiry forms ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function initForm(f) {
    var d = f.querySelector('[data-v7e-date]');
    if (d && !d.__v7e) {
      d.__v7e = 1;
      var t = new Date(); t.setDate(t.getDate() + 1);
      d.min = t.getFullYear() + '-' + pad(t.getMonth() + 1) + '-' + pad(t.getDate());
      var twin = document.createElement('input');                // the e-mail gets dd.mm.rrrr, like the catering form
      twin.type = 'hidden'; twin.name = d.name; d.removeAttribute('name');
      d.parentNode.insertBefore(twin, d.nextSibling);
      var sync = function () { var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(d.value); twin.value = m ? m[3] + '.' + m[2] + '.' + m[1] : d.value; };
      d.addEventListener('input', sync); d.addEventListener('change', sync); sync();
    }
    var up = f.querySelector('[data-v7e-up]');
    if (!up || up.__v7e) return;
    up.__v7e = 1;
    var file = up.querySelector('[data-v7e-file]'), hid = up.querySelector('[data-v7e-logo]'), txt = up.querySelector('[data-v7e-uptxt]');
    var label0 = txt ? txt.textContent : '', btn = f.querySelector('button[type=submit]'), btn0 = btn ? btn.innerHTML : '';
    function say(key, name) { if (txt) txt.textContent = String(up.getAttribute('data-t-' + key) || label0).replace('{plik}', name || ''); }
    function wait(on) {
      f.__v7eUploading = on;
      up.classList.toggle('is-busy', on);
      if (!btn) return;
      btn.disabled = on;
      if (on && up.getAttribute('data-t-wait')) btn.textContent = up.getAttribute('data-t-wait'); else if (!on) btn.innerHTML = btn0;
    }
    file.addEventListener('change', function () {
      var fl = file.files && file.files[0];
      hid.value = '';
      if (!fl) { if (txt) txt.textContent = label0; return; }
      if (!EXT.test(fl.name) || fl.size > MAX) { file.value = ''; say('type'); return; }
      var failNote = fl.name + ' ' + (up.getAttribute('data-t-suffix') || '');
      if (!window.fetch) { hid.value = failNote; say('fail', fl.name); return; }
      say('busy', fl.name);
      wait(true);
      var done = false, ctl = window.AbortController ? new AbortController() : null;
      var timer = setTimeout(function () { finish(null); if (ctl) ctl.abort(); }, 60000);
      function finish(url) {
        if (done) return; done = true; clearTimeout(timer);
        if (url) { hid.value = url; say('done', fl.name); } else { hid.value = failNote; say('fail', fl.name); }
        wait(false);
      }
      var q = '?name=' + encodeURIComponent(fl.name) + '&form=' + encodeURIComponent(up.getAttribute('data-route') || f.getAttribute('data-v7-route') || '');
      fetch(UPLOAD + q, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': fl.type || 'application/octet-stream', Accept: 'application/json' }, body: fl, signal: ctl ? ctl.signal : undefined })
        .then(function (r) { return r.ok ? r.json().catch(function () { return null; }) : null; })
        .then(function (j) { finish(j && j.ok && j.url ? String(j.url) : null); }, function () { finish(null); });
    });
  }
  // a send while the logo is still uploading waits (window capture = before batida-v7-forms.js on document)
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.__v7eUploading) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  /* ---------- wiring ---------- */
  function init(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-v7e-ss]'), function (el) { if (!el.__v7e) { el.__v7e = 1; initSS(el); } });
    Array.prototype.forEach.call(scope.querySelectorAll('[data-v7e-st]'), function (el) { if (!el.__v7e) { el.__v7e = 1; initST(el); } });
    Array.prototype.forEach.call(scope.querySelectorAll('form[data-v7e-form]'), initForm);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var g = t.closest('[data-v7e-galbtn]');
    if (g) {
      var box = g.closest('[data-v7e-gallery]'), more = box && box.querySelector('[data-v7e-galmore]');
      if (!more) return;
      var on = more.classList.toggle('is-on');
      g.textContent = on ? g.getAttribute('data-less') : g.getAttribute('data-more');
      g.setAttribute('aria-expanded', on ? 'true' : 'false');
      return;
    }
    var img = t.closest('.v7e-gal figure');
    if (img && img.querySelector('img')) { lightbox(img.querySelector('img')); return; }
    var c = t.closest('[data-v7e-cmpbtn]');
    if (c) {
      var sec = c.parentNode.querySelector('[data-v7e-cmp]');
      if (sec) { var o = sec.classList.toggle('is-on'); c.setAttribute('aria-expanded', o ? 'true' : 'false'); }
      return;
    }
    var k = t.closest('[data-v7e-setpk]');
    if (k && ST) ST.setPk(k.getAttribute('data-v7e-setpk'));
    var a = t.closest('a[href$="#wycena"]');
    if (a) prefill();
  });
  document.addEventListener('keydown', function (e) {
    if (!lb || !lb.classList.contains('is-on')) return;
    if (e.key === 'Escape') lbClose(); else if (e.key === 'ArrowRight') lbShow(lbI + 1); else if (e.key === 'ArrowLeft') lbShow(lbI - 1);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
